import { render, staticRenderFns } from "./ProductInfoPriceTable.vue?vue&type=template&id=3c7539f1&scoped=true&"
import script from "./ProductInfoPriceTable.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPriceTable.vue?vue&type=style&index=0&id=3c7539f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7539f1",
  null
  
)

export default component.exports